import React, {Component} from 'react';

class ProgressBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
			progress: 0,
			status: null
        };
    }
    
    componentDidMount() {
        this.setState({
            progress: this.props.progress
        });
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.progress !== this.props.progress) {
            this.setState({
				progress: this.props.progress,
				status: this.props.status
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(nextProps.progress !== this.props.progress) {
            return true;
        } else if(nextState.progress !== this.state.progress) {
            return true;
        }
        
        return false;
    }

    render() {        
        return (
            <div className={"progress progress-sm"}>
                <div
                    className={"progress-bar " + (this.props.className || "bg-primary") + (this.props.isIndeterminate ? " progress-bar-animated" : " ")}
                    style={this.props.isIndeterminate?  {width : '100%'} : {width: `${this.state.progress / this.props.length}%`}}>
                </div>
            </div>
        )
    }
}

export default ProgressBar;